import { useState, useRef, useEffect } from "react";
import api, { apiError } from "../lib/api";
import { PageHeader } from "../components/shared";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Bot, Send, User } from "lucide-react";

const SUGGESTIONS = [
  "What are today's total sales?",
  "List all services with prices",
  "Show me the staff and their ratings",
  "What's today's total incentive?",
];

export default function AIAssistant() {
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Hello! I'm your DEFINE SALONS assistant. Ask me about branches, services, staff, sales or incentives." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async (text) => {
    const msg = text || input;
    if (!msg.trim() || loading) return;
    setMessages((m) => [...m, { role: "user", text: msg }]);
    setInput(""); setLoading(true);
    try {
      const { data } = await api.post("/ai/chat", { message: msg });
      setMessages((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch (e) {
      setMessages((m) => [...m, { role: "assistant", text: "Sorry, I couldn't process that: " + apiError(e.response?.data?.detail) }]);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <PageHeader title="AI Assistant" subtitle="Powered by OpenAI — ask about your salon data" />
      <Card className="bg-card border-border flex flex-col h-[calc(100vh-16rem)]">
        <div className="flex-1 overflow-y-auto p-5 space-y-4" data-testid="ai-messages">
          {messages.map((m, i) => (
            <div key={i} className={`flex gap-3 ${m.role === "user" ? "flex-row-reverse" : ""}`}>
              <div className={`h-8 w-8 rounded-full flex items-center justify-center shrink-0 ${m.role === "user" ? "bg-secondary" : "bg-primary text-primary-foreground"}`}>
                {m.role === "user" ? <User size={16} /> : <Bot size={16} />}
              </div>
              <div className={`rounded-sm px-4 py-2 text-sm max-w-[80%] whitespace-pre-wrap ${m.role === "user" ? "bg-secondary" : "bg-[#1f3329]"}`}>{m.text}</div>
            </div>
          ))}
          {loading && <p className="text-muted-foreground text-sm pl-11">Thinking…</p>}
          <div ref={endRef} />
        </div>
        <div className="p-4 border-t border-border">
          <div className="flex flex-wrap gap-2 mb-3">
            {SUGGESTIONS.map((s) => (
              <button key={s} onClick={() => send(s)} className="text-xs px-3 py-1 rounded-full bg-secondary text-muted-foreground hover:text-primary border border-border">{s}</button>
            ))}
          </div>
          <div className="flex gap-2">
            <Input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Ask something…" data-testid="ai-input" className="bg-secondary" />
            <Button onClick={() => send()} disabled={loading} data-testid="ai-send" className="rounded-sm bg-primary text-primary-foreground hover:bg-[#D4AF37]"><Send size={16} /></Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
